import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/feature/ComicCard';
import { comics, comicCategories } from '@/mocks/comics';
export default function Home() {
  const hotComics = comics.filter((c) => c.isHot).slice(0, 6);
  const recommendedComics = comics.filter((c) => c.isRecommended).slice(0, 6);
  const latestComics = [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, 8);
  const showCategories = comicCategories.slice(1, 9);

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    'name': '韩国漫画免费_下拉式韩漫在线阅读_好看的漫画大全-韩漫网站',
    'description': '在这个韩漫网站，您能免费阅读下拉式韩漫全集，浏览好看的漫画大全，体验流畅的在线阅读服务，轻松发现热门作品并随时享受阅读乐趣。',
    'url': 'https://www.hanmanwangzhan.com/',
    'inLanguage': 'zh-CN',
    'isPartOf': {
      '@type': 'WebSite',
      'name': '韩漫网站',
      'url': 'https://www.hanmanwangzhan.com/',
    },
    'about': {
      '@type': 'Organization',
      'name': '韩漫网站',
      'description': '韩国漫画免费在线阅读平台',
      'url': 'https://www.hanmanwangzhan.com/',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20reading%20atmosphere%2C%20warm%20cozy%20digital%20illustration%20style%2C%20soft%20ambient%20lighting%2C%20artistic%20abstract%20background%20with%20subtle%20manga%20elements%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20clean%20minimalist%20composition&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
            alt="韩国漫画免费在线阅读 - 韩漫网站"
            title="韩国漫画免费在线阅读"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">
            <div className="animate-fade-in-up">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
                韩国漫画免费
                <span className="block text-accent-400 mt-1">下拉式韩漫在线阅读</span>
              </h1>
              <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8">
                好看的漫画大全尽在韩漫网站 —— 免费阅读热门韩国漫画，流畅的下拉式阅读体验，随时随地畅享精彩故事
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/all"
                  className="px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                  开始免费阅读
                </Link>
                <Link
                  to="/about"
                  className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white border border-white/30 rounded-full hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                  了解更多
                </Link>
              </div>
              <div className="flex items-center justify-center gap-6 mt-8 text-white/60 text-sm">
                <div className="flex items-center gap-1.5">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-book-open-line"></i>
                  </span>
                  <span>5000+ 作品</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-user-smile-line"></i>
                  </span>
                  <span>100万+ 读者</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-timer-flash-line"></i>
                  </span>
                  <span>每日更新</span>
                </div>
              </div>
            </div>
          </div>
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2">
            <span className="block w-5 h-5 flex items-center justify-center text-white/50 animate-bounce">
              <i className="ri-arrow-down-s-line text-xl"></i>
            </span>
          </div>
        </section>

        {/* Stats Bar */}
        <section className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {[
                { icon: 'ri-book-read-line', number: '5000+', label: '韩国漫画资源', color: 'text-primary-500' },
                { icon: 'ri-user-heart-line', number: '100万+', label: '活跃读者', color: 'text-accent-500' },
                { icon: 'ri-fire-line', number: '99%', label: '读者好评率', color: 'text-primary-500' },
                { icon: 'ri-refresh-line', number: '每日', label: '热门作品更新', color: 'text-accent-500' },
              ].map((stat, i) => (
                <div key={i} className="text-center">
                  <span className={`w-10 h-10 mx-auto flex items-center justify-center`}>
                    <i className={`${stat.icon} text-2xl ${stat.color}`}></i>
                  </span>
                  <div className="mt-2 text-2xl font-bold text-foreground-900">{stat.number}</div>
                  <div className="text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Comics Section */}
        <section className="py-14 md:py-20">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
                  热门韩国漫画
                </h2>
                <p className="text-foreground-500 mt-2 text-sm">
                  读者最爱的下拉式韩漫推荐，免费在线阅读
                </p>
              </div>
              <Link
                to="/category/all"
                className="hidden sm:flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              >
                查看全部
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
              {hotComics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
                漫画大全分类
              </h2>
              <p className="text-foreground-500 mt-2 text-sm">
                按类型发现更多好看的韩国漫画
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
              {showCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 rounded-lg p-5 text-center hover:bg-primary-50 transition-colors duration-200 cursor-pointer border border-background-200/70"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                >
                  <span className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-200 transition-colors duration-200">
                    <i className={`${cat.icon} text-xl`}></i>
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">
                    {cat.name}韩漫
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Recommended Comics */}
        <section className="py-14 md:py-20">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
                  编辑精选推荐
                </h2>
                <p className="text-foreground-500 mt-2 text-sm">
                  品质保证，每部都是韩国漫画精品之作
                </p>
              </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
              {recommendedComics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          </div>
        </section>

        {/* Latest Updates */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
                  最新更新
                </h2>
                <p className="text-foreground-500 mt-2 text-sm">
                  热门韩国漫画每日更新，追更不等待
                </p>
              </div>
              <Link
                to="/category/all"
                className="hidden sm:flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              >
                查看全部
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
              {latestComics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-20 md:py-28 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20atmosphere%2C%20soft%20ambient%20light%2C%20artistic%20background%20with%20subtle%20book%20and%20art%20elements%2C%20warm%20coral%20and%20golden%20tones%2C%20clean%20aesthetic%2C%20digital%20illustration%20style&width=1600&height=800&seq=cta-bg-01&orientation=landscape"
            alt="开始免费阅读韩国漫画"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60"></div>
          <div className="relative max-w-[1400px] mx-auto px-4 md:px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              立即开始您的韩漫阅读之旅
            </h2>
            <p className="text-white/80 text-base md:text-lg max-w-xl mx-auto mb-8">
              免费阅读下拉式韩漫全集，漫画大全持续更新，随时随地享受流畅的在线阅读体验
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/all"
                className="px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              >
                立即免费阅读
              </Link>
              <Link
                to="/about"
                className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white border border-white/30 rounded-full hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              >
                了解平台优势
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}